import { memo, type ReactNode } from 'react';
import { classNames } from '~/utils/classNames';

interface DangerZoneWrapperProps {
  children: ReactNode;
  title?: string;
  className?: string;
}

export const DangerZoneWrapper = memo(({ children, title = 'Danger zone', className }: DangerZoneWrapperProps) => {
  return (
    <section className={classNames('flex flex-col gap-4', className)}>
      <h3 className="font-semibold text-sm text-bolt-elements-textSecondary">{title}</h3>
      <div className="flex justify-between flex-col md:flex-row gap-2 md:gap-0">{children}</div>
    </section>
  );
});

DangerZoneWrapper.displayName = 'DangerZoneWrapper';
